module.exports = __webpack_public_path__ + "pc/static/img/card1.446e9209.png";